import { getOS, type OS } from "@/lib/utils/getDeviceOs";
import { useEffect, useState } from "react";

export const useFingerprintDecision = (
  copyLinkOptionEnabled: boolean | null | undefined
) => {
  const [os, setOs] = useState<OS | null>(null);
  const [
    shouldSendFingerprintImmediately,
    setShouldSendFingerprintImmediately,
  ] = useState<boolean | null>(null);

  useEffect(() => {
    (async () => {
      const detectedOs = getOS();
      setOs(detectedOs);

      setShouldSendFingerprintImmediately(
        detectedOs !== "ios" || !copyLinkOptionEnabled
      );
    })();
  }, [copyLinkOptionEnabled]);

  return { os, shouldSendFingerprintImmediately };
};
